import React from "react";
import {IconButton} from "@mui/material";

export const HamburgerButton = ({onClick, label = "Open menu", sx}) => (
  <IconButton onClick={onClick} aria-label={label} sx={{
    width: 34, height: 34, color: "#23264D", bgcolor: "#FAFAFD", borderRadius: "11px",
    transition: "background-color .15s ease", "&:hover": {bgcolor: "#ECECF3"},
    ...sx,
  }}>
    <svg width={18} height={18} viewBox={"0 0 18 18"} fill={"none"} stroke={"currentColor"} strokeWidth={1.8} strokeLinecap={"round"}>
      <path d={"M2.5 5h13"}/>
      <path d={"M2.5 9h13"}/>
      <path d={"M2.5 13h8"}/>
    </svg>
  </IconButton>
);
